import { DeviceWidth } from 'ecs-react-components/dist/index.es';
import { windowResize } from './window-action-creators';

export const updateWindowSize = () => (dispatch, getState) => {
  let windowSize;
  if (window.matchMedia('(max-width: ' + DeviceWidth.XSmall.maxWidth + 'px)').matches) {
    windowSize = DeviceWidth.XSmall.name;
  } else if (window.matchMedia('(max-width: ' + DeviceWidth.Small.maxWidth + 'px)').matches) {
    windowSize = DeviceWidth.Small.name;
  } else if (window.matchMedia('(max-width: ' + DeviceWidth.Medium.maxWidth + 'px)').matches) {
    windowSize = DeviceWidth.Medium.name;
  } else if (window.matchMedia('(min-width: ' + DeviceWidth.Large.minWidth + 'px)').matches) {
    windowSize = DeviceWidth.Large.name;
  }

  if (getState().window.size !== windowSize) {
    dispatch(windowResize(windowSize));
  }
};
